export default "__VITE_ASSET__DANZfNqq__"